module.exports = __webpack_public_path__ + "img/lookMore.ecadf0cf.gif";